/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HeaderComponent } from './@theme/components';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from './service/configuration.service';
import { AuthService } from './service/auth.service';

@Component({
  selector: 'ngx-app',
  template: newFunctionLayout(),
})
export class AppComponent implements OnInit {

  public TimeToLogout: Number = 0;
  public setInterval: any;
  public count: any = 0;
  public timerDefault: Number = 0; // valor em minutos

  constructor(
    private analytics: AnalyticsService,
    private headerComponent: HeaderComponent,
    private router: Router,
    private translate: TranslateService,
    private configurationService: ConfigurationService,
    private authService: AuthService,) {

    // Refresh na pagina ao clicar novamente no mesmo botão
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit() {
    this.analytics.trackPageViews();

    this.getEventRouter();

    this.getSelectedLanguage();

    this.getTimeToLogout();

    this.eventDetectedOnScreen(event);

    // identificamos eventos do mouse ou teclado se não detectar nada iniciamos a contagem de tempo para logoff
    addEventListener("mousemove", (event) => {
      this.eventDetectedOnScreen(event)
    });

    addEventListener("keydown", (event) => {
      this.eventDetectedOnScreen(event)
    })
  };

  /*Iniciamos estes metodos neste componente pra que eles não sejam recarregados sempre que hover 
    uma atualização de pagina no componente Header, assim o setInterval e o 
    metodo this.headerComponent.advertisement() não é reiniciado sempre, respeitado então o timer do setInterval
    Obs1: o compontente Header sempre é chamado quanto tem mudança de paginas.
    Obs2: este componete app não reinicia com atualização de pagina somente se der um refresh
  */
  ngAfterViewInit() {
    this.headerComponent.initSetInterval();
    this.headerComponent.advertisement();
  };

  getEventRouter() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // dentro destafunção ficamos ounvindo o evento e só atualizamos o "TimeToLogout" quando setando em "page-settings"
        if (event.url.includes('settings')) {
          this.getTimeToLogout();
        }
      }
    })
  }

  getTimeToLogout() {
    this.configurationService.getByKeyName("TimeToLogout").subscribe((resp) => {
      if (resp == null) {
        this.TimeToLogout = this.timerDefault;
        return;
      }
      if (resp.length != 0) {
        this.TimeToLogout = parseInt(resp.value);
        //console.log(this.TimeToLogout);
      } else {
        this.TimeToLogout = this.timerDefault;
      }
    });
  };

  getSelectedLanguage() {
    this.configurationService.getByKeyName("SelectedLanguage").subscribe((resp) => {
      //console.log(resp)
      if (resp != null) {
        this.translate.use(resp.value);
      } else {
        this.translate.setDefaultLang('pt');
      }
    });
  };

  eventDetectedOnScreen(event: Event) {
    this.count = 0;
    if (!this.router.url.includes('login') && this.router.url != '/') {
      clearInterval(this.setInterval);

      this.setInterval = setInterval(() => {
        this.count += 1
        console.log("Logout setado para " + this.TimeToLogout + " minutos" + " | " + this.count + " minuto(s) percorrido(s)")
        if (this.count >= this.TimeToLogout && this.TimeToLogout != 0) {
          console.log("Feito logoff automático do EasyControl por tempo de inatividade após " + this.TimeToLogout + " minutos")
          this.authService.doLogoutUser();
        }
      }, 60000);
    } else {
      clearInterval(this.setInterval);
    }
  };
}

// Função para retornar o html do layout
function newFunctionLayout(): string {
  return `
    <style>

    </style>

    <nb-layout>
      <nb-layout-header fixed>
        
      </nb-layout-header>
    
      <nb-layout-column>
        <router-outlet></router-outlet>
      </nb-layout-column>
    
      <nb-layout-footer fixed>
        <!-- Insert footer here -->
      </nb-layout-footer>
    </nb-layout>`;
}

